import { FormField } from '@dreamai/types';
import {
  CredentialRow,
  isSecretFieldName,
  makeCredentialRow,
} from './CredentialFieldEditor';

/**
 * Pure mapping helpers shared by SecureCredentialModal. Kept in their own
 * dependency-free module (no React / axios / auth0 imports) so the secret-
 * detection logic can be unit-tested without dragging the whole modal — and
 * so the modal file itself stays focused on rendering.
 */

export const capitalize = (s: string): string =>
  s.charAt(0).toUpperCase() + s.slice(1);

/**
 * Convert a legacy/artifact FormField list into the editor's row shape. Each
 * field becomes a locked-name row so callers that pass `formFields` (or an
 * artifact's `fields`) get the rigid behaviour they expect.
 *
 * `isSecret` honours the explicit `fieldType: 'password'` signal the agent
 * sets on sensitive fields (see the secure-credential artifact tool, whose
 * schema documents "Use 'password' fieldType for sensitive values"). Falling
 * back to the name heuristic alone dropped that intent, so a secret field
 * named anything other than `password`/`cvv` (e.g. `github_pat`) rendered
 * unmasked AND failed the "has at least one secret" submit gate — leaving the
 * Save/Update button permanently disabled (DRE-206).
 */
export function rowsFromFormFields(fields: FormField[]): CredentialRow[] {
  return fields.map((f) =>
    makeCredentialRow({
      name: capitalize(f.fieldId),
      value: '',
      isSecret: f.fieldType === 'password' || isSecretFieldName(f.fieldId),
      placeholder: f.placeholder ?? undefined,
      displayLabel: f.label,
    }),
  );
}
